import { getStoreFor } from 'Stores/StoreInstances'
import BaseStore from 'Stores/base_store/BaseStore'
import Businesses from 'DataServices/Businesses'
import { action } from 'mobx'

const STORE_TYPE = 'Businesses'

export function getBusinessesStoreFor (param, opts = {}) {
  return getStoreFor(BusinessesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

export class BusinessesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: true,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll (overridePayload) {
    let payload = overridePayload || {
      ...this._filter,
    }
    return Businesses.getAll(payload)
  }

  @action
  _fetchOne () {
    return Businesses.getById(this._filter.id)
  }
}
